import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as QuestionCircle } from "../../../images/question-circle.svg";
import { handleSubmitModalChange } from "../../../redux/features/timer/timerSlice";
import { submitExam } from "../../../redux/activityAsyncAction";

const ConfirmSubmitModal = () => {
  const list = useSelector((state) => state.questions.list);
  const submitShow = useSelector((state) => state.timer.submitShow);
  const examEnded = useSelector((state) => state.timer.examEnded);
  const submitted = useSelector((state) => state.examDetail.submitted);
  console.log("this is the submit exam", submitted);
  const submissionLoading = useSelector(
    (state) => state.examDetail.submissionLoading
  );
  const dispatch = useDispatch();

  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(false);

  return (
    <>
      <Modal
        show={submitShow || examEnded}
        // show={true}
        onHide={() => dispatch(handleSubmitModalChange())}
        animation={true}
        keyboard={false}
        centered
      >
        <Modal.Body className="px-4 pt-4">
          {examEnded ? (
            <div className="d-flex flex-column px-4">
              <h6 className="fw-bold">Your Assesment has Ended</h6>
              {submissionLoading && (
                <p className="text-info">automatic submission ongoing......</p>
              )}
              {submitted && (
                <p className="text-info">
                  Your exam has been submitted successfully
                </p>
              )}
            </div>
          ) : (
            <div className="d-flex">
              <QuestionCircle className="" />
              <div className="d-flex flex-column px-4">
                <h6 className="fw-bold">Do you Want to Submit your exam?</h6>
                <p className="text-info">
                  Once you have submitted, you will be unable to edit your
                  answers
                </p>
                <p className="text-secondary mb-0">{`(${
                  list.filter((x) => !x.answer).length
                } unanswered questions)`}</p>
              </div>
            </div>
          )}
        </Modal.Body>
        {!examEnded && (
          <Modal.Footer className="pt-0 border-0 px-5 pb-4">
            <Button
              variant="outline-info"
              disabled={submissionLoading}
              onClick={() => {
                // history.push("/");
                dispatch(submitExam());
              }}
            >
              {submissionLoading && (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Loading...</span>
                </>
              )}
              Submit
            </Button>
            <Button
              variant="primary"
              onClick={() => dispatch(handleSubmitModalChange())}
            >
              Review
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default ConfirmSubmitModal;
